import { createFileRoute } from "@tanstack/react-router";
import { EntityListPage } from "@/components/catalog/entity-pages";
import { type EntitySearch, entitySearchSchema } from "@/lib/catalog";

export const Route = createFileRoute("/_app/_library/series/")({
  validateSearch: entitySearchSchema,
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <EntityListPage
      kind="series"
      search={search}
      onSearchChange={(patch: Partial<EntitySearch>) =>
        void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: "q" in patch })
      }
    />
  );
}
